import { Trans } from '@lingui/react/macro';
import { LoadingIndicator, Toast, ProjectWhiteLabelSettings } from '@ygtechnologies/bygr-frontend-component-library';
import React from 'react';
import {
    getWhiteLabelLogoUrl,
    deleteWhiteLabelLogo,
    getProjectWhiteLabel,
    saveProjectWhiteLabel,
} from '@/services/white-label';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import theme from './WhiteLabelSettings.module.scss';

interface ProjectWhiteLabelProps {
    projectId: number;
}

const WhiteLabelSettings: React.FC<ProjectWhiteLabelProps> = ({ projectId }) => {
    const [whiteLabel, setWhiteLabel, reload] = useAsyncStateWithIsLoading(
        () => getProjectWhiteLabel(projectId),
        [projectId],
        null
    );

    const handleDeleteLogo = async () => {
        if (whiteLabel) {
            await deleteWhiteLabelLogo(projectId);
        }
    };

    if (!whiteLabel) return <LoadingIndicator />;
    return (
        <div className={theme.container}>
            <ProjectWhiteLabelSettings
                onChange={setWhiteLabel}
                onReload={reload}
                onSave={async (whiteLabelToSave, logo) => {
                    await saveProjectWhiteLabel(projectId, whiteLabelToSave, logo);
                    Toast.success(<Trans>Saved</Trans>);
                }}
                whiteLabel={whiteLabel}
                whiteLabelLogoUrl={getWhiteLabelLogoUrl(projectId)}
                onDeleteLogo={handleDeleteLogo}
            />
        </div>
    );
};

export default WhiteLabelSettings;
